import { ExportJsonCsv } from 'react-export-json-csv';

interface Props {
    headers: {
        key: string;
        name: string;
    }[];
    rows: any[];
    fileName: string;
}

export const ExportToCsvButton = ({ headers, rows, fileName }: Props) => {
    return (
        <ExportJsonCsv style={{ all: 'unset' }} headers={headers} items={rows} fileTitle={fileName}>
            Export to CSV
        </ExportJsonCsv>
    );
};
